/**
 * FDA enforcement-letter results table.  Consumed by BOTH the keyword
 * "FDA Letters" corpus AND the Cogni AI letter search path — the prop
 * is the row list directly so neither caller has to wrap its response
 * in a particular schema.
 *
 * The keyword path passes ``keywordSearchQuery.data.results`` (rows
 * from ``KeywordLetterSearchResponse``); the Cogni AI path passes
 * ``letterSearchQuery.data.results`` (rows from
 * ``LetterAISearchResponse``).  Both row lists are
 * ``LetterKeywordResultItem[]`` so the renderer is symmetric.
 *
 * Renders an empty state when the list is empty, otherwise a vertical
 * list of ``LetterResultRow`` cards.  Owns navigation for each row: a row
 * (or drug chip) click opens the target in a NEW browser tab so the user
 * keeps their results list, routing to either the linked-drug viewer or the
 * dedicated FDA letter detail page.
 */
import React from 'react';
import type { LetterKeywordResultItem } from '../types';
import { LetterResultRow } from './LetterResultRow';
import { openInNewTab } from '../utils/openInNewTab';

interface Props {
  results: LetterKeywordResultItem[];
}

export const LetterResultsTable: React.FC<Props> = ({ results }) => {
  if (results.length === 0) {
    return (
      <div className="text-center text-slate-500 py-12">
        No matching FDA Enforcement Letters found.
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {results.map((letter) => (
        <LetterResultRow
          key={letter.letter_id}
          letter={letter}
          onClick={({ target }) => openInNewTab(target)}
        />
      ))}
    </div>
  );
};

export default LetterResultsTable;
